import { animate, group, keyframes, query, state, style, transition, trigger } from '@angular/animations';

const ANIMATION_SPEED = '.3s';
const ANIMATION_ROUND_BUTTON_SELECTOR = 'ccwb-round-button';
const BUTTON_DIMENSION_IN_PX = '48px';
const BUTTON_PADDING = '0 calc(var(--wb-spacing-xs) / 2)'; // padding as defined in CSS

export const awesomeStageComponentAnimations = [
  trigger('fadeOut', [
    state('false', style({ opacity: 0.8 })),
    state('true', style({ opacity: 0 })),
    transition('false => true', animate('1s ease-out'))
  ]),
  trigger('inOutAnimation', [
    transition(':enter', [style({ opacity: 0 }), animate('.2s ease-out', style({ opacity: 1 }))]),
    transition(':leave', [style({ opacity: 1 }), animate('.2s ease-in', style({ opacity: 0 }))])
  ]),
  trigger('buttonWrapperAnimation', [
    transition(':enter', [
      style({ opacity: 0, width: 0, height: 0, padding: 0 }),
      query(ANIMATION_ROUND_BUTTON_SELECTOR, style({ transform: 'scale(0)' })),
      group([
        animate(
          `${ANIMATION_SPEED} ease-out`,
          style({
            opacity: 1,
            width: BUTTON_DIMENSION_IN_PX,
            height: BUTTON_DIMENSION_IN_PX,
            padding: BUTTON_PADDING
          })
        ),
        query(
          ANIMATION_ROUND_BUTTON_SELECTOR,
          animate(
            ANIMATION_SPEED,
            keyframes([
              style({ transform: 'scale(0)', offset: 0.5 }),
              style({ transform: 'scale(0.2)', offset: 0.6 }),
              style({ transform: 'scale(0.4)', offset: 0.7 }),
              style({ transform: 'scale(0.6)', offset: 0.8 }),
              style({ transform: 'scale(0.8)', offset: 0.9 }),
              style({ transform: 'scale(1)', offset: 1 })
            ])
          )
        )
      ])
    ]),
    transition(':leave', [
      style({
        opacity: 1,
        width: BUTTON_DIMENSION_IN_PX,
        height: BUTTON_DIMENSION_IN_PX,
        padding: BUTTON_PADDING
      }),
      query(ANIMATION_ROUND_BUTTON_SELECTOR, style({ transform: 'scale(1)' })),
      group([
        animate(`${ANIMATION_SPEED} ease-in`, style({ opacity: 0, width: 0, height: 0, padding: '0 0' })),
        query(
          ANIMATION_ROUND_BUTTON_SELECTOR,
          animate(
            ANIMATION_SPEED,
            keyframes([
              style({ transform: 'scale(1)', offset: 0 }),
              style({ transform: 'scale(0.8)', offset: 0.1 }),
              style({ transform: 'scale(0.6)', offset: 0.2 }),
              style({ transform: 'scale(0.4)', offset: 0.3 }),
              style({ transform: 'scale(0.2)', offset: 0.4 }),
              style({ transform: 'scale(0)', offset: 0.5 })
            ])
          )
        )
      ])
    ])
  ])
];
